const stepsRubros = [
    {
        id: 1,
        img: "/assets/cerv/elearning/icon_seguridad.png",
        title: "Seguridad",
        desc: "",
        number: "01",
        link: "#"
    },
    {
        id: 2,
        img: "/assets/cerv/elearning/icon_operaciones.png",
        title: "Operaciones",
        desc: "",
        number: "02",
        link: "#"
    },
    {
        id: 3,
        img: "/assets/cerv/elearning/icon_operaciones.png",
        title: "Mantenimiento",
        desc: "",
        number: "03",
        link: "#"
    },
]

const stepsElearning = [
    {
        id: 1,
        img: "/assets/cerv/elearning/area_Altoriesgo.png",
        title: "Seguridad",
        desc: "Videos",
        number: "01",
        link: "#"
    },
    {
        id: 2,
        img: "/assets/cerv/elearning/area_equipos.png",
        title: "Operaciones",
        desc: "Talleres 360º",
        number: "02",
        link: "#"
    },
    {
        id: 3,
        img: "/assets/cerv/elearning/area_manejar.png",
        title: "Mantenimiento",
        desc: "Interactivos",
        number: "03",
        link: "#"
    },
    {
        id: 4,
        img: "/assets/cerv/elearning/area_pala.png",
        title: "Evaluaciones",
        desc: "Evaluaciones progresivas",
        number: "04",
        link: "#"
    }
]

const eventParticipation = {
    title: "Participación en eventos y ferias",
    description: [],
    photo: "https://www.youtube.com/watch?v=9Nb_sdU5qFQ",
    type: "video",
    textPosition: "left",
    overlayBackground: "rgb(14 3 39 / 50%)"
}

const cursso = {
    title: "Aprende en nuestra plataforma interactiva CurSSO",
    description: [
        "Plataforma web de fácil acceso en diferentes dispositivos.",
        "Contenido interactivo microlearning.",
        "Gamificación (entornos 3d interactivos).",
        "Información centralizada, disponible 24/7.",
        "Combinamos metodologías de conductismo, constructivismo y gamificación para motivar el pensamiento critico."
    ],
    photo: "https://grupomexico.s3.us-east-2.amazonaws.com/tutorialgrupomexico.mp4",
    type: "video",
    textPosition: "left",
    overlayBackground: "linear-gradient(rgb(16 9 62) 3.92%, rgba(9, 18, 29, 0) 36.79%, rgb(24 11 55) 83.98%), url('/assets/images/backgroup/bg_pagetitle.png') center center no-repeat"
}

export { stepsRubros, stepsElearning, eventParticipation, cursso };